import React from "react";
import {
  Form,
  Row,
  InputGroup,
  FormControl,
  Button,
  Modal,
  Col,
} from "react-bootstrap";
import { ErrorMessage, Field, FieldArray, Formik } from "formik";
import EditIcon from "@material-ui/icons/Edit";
import { Box, FormGroup, IconButton } from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
import { ButtonDanger } from "../../ui/templates/buttons";
import { AddCircleOutline, DeleteOutline } from "@material-ui/icons";
import { ALL_LICENSE_TYPES } from "./../../ui/constants";
import { handleLicenseTypeChange } from "../../utils";
class Licence extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
  }

  handleOpenModal = () => {
    this.setState({ showModal: true });
  };

  handleCloseModal = () => {
    this.setState({
      showModal: false,
    });
  };

  validateLicense = (value) => {
    let error;
    if (value === "") {
      error = "empty field";
    }
    return error;
  };

  render() {
    const {
      id,
      license,
      team,
      handleEventDetailsPush,
      handleDriverLicenseUpdate,
      user_id,
      editAbleLicense,
      findByRole,
    } = this.props;

    const { showModal } = this.state;

    return (
      <>
        <Formik
          initialValues={{
            id: user_id,
            license: license || ALL_LICENSE_TYPES,
            licenses: JSON.parse(editAbleLicense || '[]'),
          }}
          validate={(values) => {
            let errors = {
              license: this.validateLicense(values.license),
            };

            Object.keys(errors).forEach((key) => {
              if (errors[key] === undefined) {
                delete errors[key];
              }
            });
            return errors;
          }}
        >
          {({
            values,
            handleChange,
            handleSubmit,
            handleBlur,
            resetForm,
            setFieldValue,
          }) => (
            <Form
              onSubmit={(...args) => {
                return handleSubmit(...args);
              }}
            >
              <Form.Group as={Row}>
                <Box className="col-12 licenceExpiry">
                  <Box
                    className="col-12"
                    display="flex"
                    justifyContent="space-between"
                  >
                    <Box className="bold">
                      Race Licence
                      <small className="bold">(s)</small>
                    </Box>
                    {user_id && !findByRole(team) && (
                      <Box
                        variant="primary"
                        style={{ cursor: "pointer", color: "#e00000" }}
                        onClick={this.handleOpenModal}
                      >
                        <EditIcon />
                      </Box>
                    )}
                  </Box>
                  <Box className="col-12">
                    {values?.license?.map((item) => {
                      return (
                        <InputGroup className="mb-3 bold licenceInputs">
                          <Box>
                            <FormControl
                              id={id}
                              type="text"
                              placeholder="Race licence Type"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={item?.licenseType}
                              name="licenseType"
                              disabled
                            />
                            <FormControl
                              id={id}
                              type="text"
                              placeholder="Race licence number needed to complete registration"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={item?.licenseNumber}
                              name="licenseNumber"
                              disabled
                            />
                            <FormControl
                              type="date"
                              placeholder="Race licence Expiry"
                              name="date"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={item?.date_of_exp}
                              disabled
                            />
                          </Box>
                        </InputGroup>
                      );
                    })}
                    {values?.license?.length === 0 && (
                      <InputGroup className="mb-3 bold licenceInputs">
                        <FormControl
                          id={id}
                          type="text"
                          placeholder="Race licence Type"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value=""
                          name="licenseType_empty"
                          disabled
                        />
                        <FormControl
                          id={id}
                          type="text"
                          placeholder="Race licence number needed to complete registration"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value=""
                          name="licenseNumber_empty"
                          disabled
                        />
                        <FormControl
                          type="date"
                          placeholder="Race licence Expiry"
                          name="expiryDate_empty"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value=""
                          disabled
                        />
                      </InputGroup>
                    )}
                    <ErrorMessage
                      name="license"
                      className="error-msg"
                      component="div"
                    />
                    <Box display={["block", "flex"]}>
                      <Box style={{ margin: "10px 10px 10px 0px" }}>
                        <Button
                          variant="outline-danger"
                          onClick={() =>
                            handleEventDetailsPush(team.team_info.event_id)
                          }
                        >
                          Please check Event details for licence requirements
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Form.Group>

              <Modal
                show={showModal}
                onHide={
                  this.handleOpenModal
                }
              >
                <Modal.Header className="bg-danger text-white">
                  <Modal.Title>
                    <span
                      className="modal-title"
                      style={{
                        color: "white",
                        height: "30px",
                        fontWeight: "700",
                        fontFamily: "Segoe UI",
                        fontSize: "16px",
                      }}
                    >
                      Edit Race Licence
                    </span>
                  </Modal.Title>
                  <CancelIcon
                    onClick={() => {
                      resetForm();
                      this.handleCloseModal();
                    }}
                    style={{
                      color: "white",
                      cursor: "pointer",
                      outline: "none",
                    }}
                  />
                </Modal.Header>
                <Modal.Body>
                  <FieldArray name="licenses">
                    {({ remove, push }) => (
                      <div>
                        {values?.licenses?.map((license, index) => {
                          const selectedLicenseTypes = values?.licenses
                            .filter((_, i) => i !== index)
                            .map((lic) => lic?.licenseType);

                          const availableLicenseTypes =
                            ALL_LICENSE_TYPES?.filter(
                              (type) => !selectedLicenseTypes.includes(type)
                            );
                          return (
                            <div key={index}>
                              <Box
                                display="flex"
                                flexDirection="column"
                                className="edit-license-screen"
                              >
                                <Box width="100%" padding="0 16px" order={2}>
                                  <FormGroup className="adjustMargin">
                                    <Form.Label className="InputformLabel">
                                      Type
                                    </Form.Label>

                                    <Field
                                      as="select"
                                      name={`licenses[${index}].licenseType`}
                                      className="form-control widthcontrol-form"
                                      onChange={(event) =>
                                        handleLicenseTypeChange(
                                          event,
                                          index,
                                          values,
                                          setFieldValue
                                        )
                                      }
                                    >
                                      {availableLicenseTypes?.map((item) => (
                                        <option key={item} value={item}>
                                          {item}
                                        </option>
                                      ))}
                                    </Field>
                                  </FormGroup>
                                </Box>
                                <Box width="100%" padding="0 16px" order={3}>
                                  <FormGroup className="adjustMargin">
                                    <Form.Label className="InputformLabel">
                                      Number
                                    </Form.Label>

                                    <Field
                                      type="text"
                                      name={`licenses[${index}].licenseNumber`}
                                      placeholder="License Number"
                                      className="form-control widthcontrol-form"
                                    />
                                  </FormGroup>
                                </Box>
                                <Box width="100%" padding="0 16px" order={4}>
                                  <FormGroup as={Col} className="adjustMargin">
                                    <Form.Label className="InputformLabel">
                                      Expiry
                                    </Form.Label>

                                    <Field
                                      type="date"
                                      name={`licenses[${index}].date_of_exp`}
                                      placeholder="yyyy-mm-dd"
                                      className="form-control widthcontrol-form"
                                    />
                                  </FormGroup>
                                </Box>

                                <Box
                                  mb="-45px"
                                  mt="-15px"
                                  width="100%"
                                  display="flex"
                                  justifyContent="end"
                                  order={1}
                                  className="delete-icon"
                                >
                                  <FormGroup className="adjustMargin">
                                    <Form.Label className="InputformLabel"></Form.Label>
                                    <Box
                                      mt={2}
                                      className="deleteIconMemberArea edit_license_delete"
                                    >
                                      <IconButton
                                        id="deleteHoverNone"
                                        style={{
                                          background: "none",
                                          paddingRight: "12px !important",
                                          paddingLeft: "0 !important",
                                          paddingTop: "0 !important",
                                          paddingBottom: "0 !important",
                                        }}
                                        onClick={() => remove(index)}
                                        disabled={
                                          values?.licenses?.length === 1
                                        }
                                      >
                                        <DeleteOutline />
                                      </IconButton>
                                    </Box>
                                  </FormGroup>
                                </Box>
                              </Box>
                            </div>
                          );
                        })}
                        <Box display="flex" alignItems="center">
                          <Box width="100%" border="1px solid #dcdcdc" m={2} />
                          <IconButton
                            id="noHover"
                            style={{ color: "#E00000", background: "none" }}
                            disabled={values?.licenses?.length === 2}
                            onClick={() => {
                              const usedLicenseTypes = values?.licenses?.map(
                                (license) => license.licenseType
                              );
                              const availableLicenseTypes =
                                ALL_LICENSE_TYPES.filter(
                                  (item) => !usedLicenseTypes.includes(item)
                                );
                              push({
                                licenseType: availableLicenseTypes[0] || "",
                                licenseNumber: "",
                                date_of_exp: "",
                              });
                            }}
                          >
                            <AddCircleOutline fontSize="small" />
                            <span
                              style={{
                                fontSize: "16px",
                                color: "black",
                                marginLeft: "5px",
                                fontWeight: "400",
                                textShadow: "none",
                              }}
                            >
                              Add License
                            </span>
                          </IconButton>
                          <Box width="100%" border="1px solid #dcdcdc" m={2} />
                        </Box>
                      </div>
                    )}
                  </FieldArray>
                </Modal.Body>
                <Modal.Footer>
                  <InputGroup.Append>
                    <ButtonDanger
                      onClick={() => {
                        handleDriverLicenseUpdate(
                          JSON.stringify(values.licenses),
                          values.id
                        );
                        this.handleCloseModal();
                        resetForm();
                      }}
                      text="SAVE"
                    />
                  </InputGroup.Append>
                </Modal.Footer>
              </Modal>
            </Form>
          )}
        </Formik>
      </>
    );
  }
}

export default Licence;
